import type { NskResponse } from "~/models/Api";
import type { DealVendorCompanyUpdateParam } from "~/models/DealVendorCompany";
import { postRequest, putRequest } from "~/utils/api/api_handler";

const paths = {
	create: "/deals/:deal_id/deal_vendor_companies",
	update: "/deals/:deal_id/deal_vendor_companies/:id"
};

export const create = async (
	dealId: number,
	companyVendorId: number,
	showTenant: boolean,
	estimationByCompany: boolean
): Promise<NskResponse> =>
	postRequest(paths.create.replace(":deal_id", String(dealId)), {
		companyVendorId,
		estimationByCompany,
		showTenant
	});

export const update = async (
	dealId: number,
	dealVendorCompanyId: number,
	dealVendorCompany: DealVendorCompanyUpdateParam
): Promise<NskResponse> =>
	putRequest(
		paths.update
			.replace(":deal_id", String(dealId))
			.replace(":id", String(dealVendorCompanyId)),
		{ dealVendorCompany }
	);
